import {createFileRoute} from '@tanstack/react-router'
import RyderCupRoundView from "../../../rydercup/RyderCupRoundView.tsx";

export const Route = createFileRoute('/_app/rydercup/$uid/round/$roundNumber')({
    component: RouteComponent,
})

function RouteComponent() {
    return <RyderCupRoundView />
}
